import React, {Component} from 'react';
import $ from 'jquery';
import {json} from '../libs/utils/Const';


class UserFieldsInventoryModal extends Component {

    closeUserFields = async () => {
        $('#userFieldsInventoryModal').modal('hide');
    };

    closeAction = () => {
        $('#userFieldsInventoryModal').on('hiden.bs.modal', function () {
            //console.log("cerrar Campos Usuario", json);
        });
    };

    changeUserFieldsDocument = (event, index) => {
        const {inventoryModel, refreshModel} = this.props;
        switch (index) {
            case 0:
                inventoryModel.userFields.userFields1 = event.nativeEvent.target.value;
                break;
            case 1:
                inventoryModel.userFields.userFields2 = event.nativeEvent.target.value;
                break;
            case 2:
                inventoryModel.userFields.userFields3 = event.nativeEvent.target.value;
                break;
            case 3:
                inventoryModel.userFields.userFields4 = event.nativeEvent.target.value;
                break;
            case 4:
                inventoryModel.userFields.userFields5 = event.nativeEvent.target.value;
                break;
            case 5:
                inventoryModel.userFields.userFields6 = event.nativeEvent.target.value;
                break;
            case 6:
                inventoryModel.userFields.userFields7 = event.nativeEvent.target.value;
                break;
            case 7:
                inventoryModel.userFields.userFields8 = event.nativeEvent.target.value;
                break;
            case 8:
                inventoryModel.userFields.userFields9 = event.nativeEvent.target.value;
                break;
            case 9:
                inventoryModel.userFields.userFields10 = event.nativeEvent.target.value;
                break;
            case 10:
                inventoryModel.userFields.userFields11 = event.nativeEvent.target.value;
                break;
            case 11:
                inventoryModel.userFields.userFields12 = event.nativeEvent.target.value;
                break;
            case 12:
                inventoryModel.userFields.userFields13 = event.nativeEvent.target.value;
                break;
            case 13:
                inventoryModel.userFields.userFields14 = event.nativeEvent.target.value;
                break;
            case 14:
                inventoryModel.userFields.userFields15 = event.nativeEvent.target.value;
                break;
            case 15:
                inventoryModel.userFields.userFields16 = event.nativeEvent.target.value;
                break;
            case 16:
                inventoryModel.userFields.userFields17 = event.nativeEvent.target.value;
                break;
            case 17:
                inventoryModel.userFields.userFields18 = event.nativeEvent.target.value;
                break;
            case 18:
                inventoryModel.userFields.userFields19 = event.nativeEvent.target.value;
                break;
            case 19:
                inventoryModel.userFields.userFields20 = event.nativeEvent.target.value;
                break;
            case 20:
                inventoryModel.userFields.userFields21 = event.nativeEvent.target.value;
                break;
            case 21:
                inventoryModel.userFields.userFields22 = event.nativeEvent.target.value;
                break;
            case 22:
                inventoryModel.userFields.userFields23 = event.nativeEvent.target.value;
                break;
            case 23:
                inventoryModel.userFields.userFields24 = event.nativeEvent.target.value;
                break;
            case 24:
                inventoryModel.userFields.userFields25 = event.nativeEvent.target.value;
                break;
            case 25:
                inventoryModel.userFields.userFields26 = event.nativeEvent.target.value;
                break;
            case 26:
                inventoryModel.userFields.userFields27 = event.nativeEvent.target.value;
                break;
            case 27:
                inventoryModel.userFields.userFields28 = event.nativeEvent.target.value;
                break;
            case 28:
                inventoryModel.userFields.userFields29 = event.nativeEvent.target.value;
                break;
            case 29:
                inventoryModel.userFields.userFields30 = event.nativeEvent.target.value;
                break;
            case 30:
                inventoryModel.userFields.userFields31 = event.nativeEvent.target.value;
                break;
            case 31:
                inventoryModel.userFields.userFields32 = event.nativeEvent.target.value;
                break;
            case 32:
                inventoryModel.userFields.userFields33 = event.nativeEvent.target.value;
                break;
            case 33:
                inventoryModel.userFields.userFields34 = event.nativeEvent.target.value;
                break;
            case 34:
                inventoryModel.userFields.userFields35 = event.nativeEvent.target.value;
                break;
            default:
                break
        }

        refreshModel(inventoryModel);
    };

    returnValue = index => {
        const {inventoryModel} = this.props;
        let value = "";
        switch (index) {
            case 0:
                value = inventoryModel.userFields ? inventoryModel.userFields.userFields1: "";                
                break;
            case 1:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields2: "";
                break;
            case 2:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields3: "";
                break;
            case 3:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields4: "";
                break;
            case 4:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields5: "";
                break;
            case 5:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields6: "";
                break;
            case 6:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields7: "";
                break;
            case 7:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields8: "";
                break;
            case 8:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields9: "";
                break;
            case 9:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields10: "";
                break;
            case 10:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields11: "";
                break;
            case 11:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields12: "";
                break;
            case 12:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields13: "";
                break;
            case 13:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields14: "";
                break;
            case 14:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields15: "";
                break;
            case 15:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields16: "";
                break;
            case 16:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields17: "";
                break;
            case 17:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields18: "";
                break;
            case 18:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields19: "";
                break;
            case 19:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields20: "";
                break;
            case 20:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields21: "";
                break;
            case 21:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields22: "";
                break;
            case 22:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields23: "";
                break;
            case 23:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields24: "";
                break;
            case 24:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields25: "";
                break;
            case 25:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields26: "";
                break;
            case 26:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields27: "";
                break;
            case 27:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields28: "";
                break;
            case 28:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields29: "";
                break;
            case 29:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields30: "";
                break;
            case 30:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields31: "";
                break;
            case 31:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields32: "";
                break;
            case 32:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields33: "";
                break;
            case 33:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields34: "";
                break;
            case 34:
                value = inventoryModel.userFields? inventoryModel.userFields.userFields35: "";
                break;
            default:
                break
        }

        return value;
    }

    renderFieldType1 = (json) => {
        const {action, editMode} = this.props;
        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <input className="form-control" type="text" onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}
                           disabled={(action == 2 && !editMode) ? true : false}
                           value={this.returnValue(json.IdValue)}/>
                </td>
            </tr>
        )
    }

    renderFieldType2 = (json) => {
        const {action, editMode} = this.props;
        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <select className="form-control"  disabled={(action == 2 && !editMode) ? true : false} value={this.returnValue(json.IdValue)} onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}>
                        {json.options.map( option =>{
                            return (
                                <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                            )
                        })}
                    </select>
                </td>
            </tr>
        )
    }

    renderUserFieldsPartner = () => {
        const {inventoryModel, action, editMode} = this.props;
        return (
            <tbody>

            {json.userFieldsPartners.map((field) => {
                if (field.fieldType == 1 && field.enabled) {
                    return this.renderFieldType1(field);
                } else if (field.fieldType == 2 && field.enabled) {
                    return this.renderFieldType2(field);
                }
            })}

            </tbody>
        )

    };

    renderUserFieldsInventory = () => {
        const {inventoryModel, action, editMode} = this.props;
        return (
            <tbody>

            {json.userFieldsInventory.map((field) => {
                if (field.fieldType == 1 && field.enabled) {
                    return this.renderFieldType1(field);
                } else if (field.fieldType == 2 && field.enabled) {
                    return this.renderFieldType2(field);
                }
            })}

            </tbody>
        )

    };

    renderUserFieldsPayment = () => {
        const {inventoryModel, action, editMode} = this.props;

        //console.log("dddddddddddddddddddddddddddddddddd",editMode, action);
        return (
            <tbody>

            {json.userFieldsPayment.map((field) => {
                if (field.fieldType == 1 && field.enabled) {
                    return this.renderFieldType1(field);
                } else if (field.fieldType == 2 && field.enabled) {
                    return this.renderFieldType2(field);
                }
            })}

            </tbody>
        )
    }

    renderUserFields = () => {
        const {view} = this.props;

        let body = <tbody></tbody>;
        switch (view) {
            case 'payment':
                body = this.renderUserFieldsPayment();
                break;
            case 'bussinesPartner':
                body = this.renderUserFieldsPartner();
                break;
            case 'inventoryData':
                body = this.renderUserFieldsInventory();
                 break;
            default:
                break;
        }
        return body;
    };

    render() {
        const {inventoryModel, action, refreshModel, editMode, view} = this.props;
        return (
            <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="userFieldsInventoryModal"
                 style={{zIndex: 91}} role="dialog" aria-labelledby="userFieldsInventoryModal" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                             style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">Campos de Usuario</h4>
                            <button type="button" className="close" onClick={this.closeUserFields} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active "
                                             aria-labelledby="nav-home-tab-Contenido"
                                             style={{maxHeight: 560}}>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                <tr>
                                                    <td className="sticky-header table-header-yellow ">Nombre</td>
                                                    <td className="sticky-header table-header-yellow "
                                                        style={{width: 250, textAlign: "center"}}> Valor
                                                    </td>
                                                </tr>
                                                {this.renderUserFields()}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                    onClick={this.closeUserFields}>Cerrar
                            </button>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        );
    }
}

export default UserFieldsInventoryModal;